export const environment = {
    production: true,
    hmr: false,
    stage: false,
    baseApiUrl: 'https://kwnyc-api.myplacenyc.com/',
    baseGraphQlUrl: 'https://gateway.allaccessnyc.com/graphql',
    notificationsApiUrl: 'https://notifications.allaccessnyc.com/'
};
